export default "__VITE_ASSET__ot3zdt2c__"